import { ref } from 'vue';

/**
 * The Deep Chat element of the currently mounted Chatbot, which its custom elements (the response
 * toolbar and the tool approval request) read to reach the chat they were rendered in.
 *
 * Shared at module level rather than created per Chatbot instance because customElements.define
 * registers each custom element class once, globally, and those classes close over whatever they
 * were provided on first registration. Chatbot is mounted behind a staff/feature-flag check, so
 * it can be unmounted and remounted; an instance-local ref would leave the custom elements
 * holding the first instance's Deep Chat forever. Only one Chatbot is mounted at a time (App.vue
 * renders a single one), so a single shared ref tracks whichever instance is live.
 */
export const deepChatRef = ref(null);
